import { createSlice } from '@reduxjs/toolkit';

const getMenuItems = (user) => {
  if (!user) return [];

  const baseMenuItems = [
    { id: 1, label: "My Account", icon: "myAccount", path: "/my-account" },
    { id: 2, label: "Transactions", icon: "wallet", path: "/transactions" },
    // { id: 3, label: "Bank Details", icon: "bank", path: "/bank-details" },
    { id: 6, label: "Invoices & PODs", icon: "invoice", path: "/invoices-pods" },
    { id: 4, label: "Help", icon: "help", path: "/help" },
  ];

  if (user?.role === 'SHIPPER') {
    baseMenuItems.splice(1, 0, { id: 5, label: "Company Info", icon: "myAccount", path: "/company-info" });
  }

  return baseMenuItems;
};

const initialUser = JSON.parse(localStorage.getItem('userData')) || null;

const initialState = {
  user: initialUser,
  isLoggedIn: !!localStorage.getItem('accessToken'),
  menuItems: getMenuItems(initialUser),
  loading: false,
  error: null,
  successMessage: null,
};

const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    updateBalance: (state, action) => {
      if (state.user) {
        state.user.balance = action.payload;
        const currentUser = JSON.parse(localStorage.getItem('userData') || '{}');
        currentUser.balance = action.payload;
        localStorage.setItem('userData', JSON.stringify(currentUser));
      }
    },
    logout: (state) => {
      state.isLoggedIn = false;
      state.user = null;
      state.loading = false;
      state.error = null;
      state.successMessage = null;
      state.menuItems = [];
      localStorage.removeItem('accessToken');
      localStorage.removeItem('userData');
      localStorage.removeItem('walletAccountLinked');
      localStorage.removeItem('walletData');
      localStorage.removeItem('walletBalance');
      localStorage.removeItem('walletReturnPath');
      localStorage.removeItem('bankAccounts');
    },
    login: (state, action) => {
      state.isLoggedIn = true;
      state.user = { ...state.user, ...action.payload };
      state.menuItems = getMenuItems(state.user);
    },
    clearProfileError: (state) => {
      state.error = null;
    },
    clearProfileSuccess: (state) => {
      state.successMessage = null;
    },
    syncUserFromAuth: (state, action) => {
      if (action.payload) {
        state.user = action.payload;
        state.isLoggedIn = true;
        state.menuItems = getMenuItems(action.payload);
      }
    },
    setProfileLoading: (state, action) => {
      state.loading = action.payload;
    },
    setProfileError: (state, action) => {
      state.error = action.payload;
    },
    setProfileSuccess: (state, action) => {
      state.successMessage = action.payload;
    },
    setUser: (state, action) => {
      if (action.payload) {
        state.user = action.payload;
        state.menuItems = getMenuItems(action.payload);
        state.isLoggedIn = true;
        const currentUser = JSON.parse(localStorage.getItem('userData') || '{}');
        const mergedUser = { ...currentUser, ...action.payload };
        localStorage.setItem('userData', JSON.stringify(mergedUser));
      } else {
        state.user = null;
        state.menuItems = [];
        state.isLoggedIn = false;
      }
    },
  },
});

export const {
  updateBalance,
  logout,
  login,
  clearProfileError,
  clearProfileSuccess,
  syncUserFromAuth,
  setProfileLoading,
  setProfileError,
  setProfileSuccess,
  setUser,
} = profileSlice.actions;

export default profileSlice.reducer;